function handleTitles() {
    $(".description").find("h3").each(function () {
        var first = $(this).text().substr(0,1),
            rest = $(this).text().substring(1);

        $(this).html(first + "<span>" + rest + "</span>")
    });
}


handleTitles();